import PropTypes from "prop-types";
import doneIconWhite from "assets/icons/doneIconWhite.svg";
import styled from "styled-components";
import { useState } from "react";

const Wrapper = styled.div`
  label {
    margin-left: 1.2rem;
    cursor: pointer;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  height: 2.4rem;
  width: 2.4rem;
  border: 1px solid ${(props) => (props.checked ? "var(--primary)" : "#cccccc")};
  border-radius: ${(props) => (props.circle ? "100%" : "4px")};
  background-color: ${(props) =>
    props.checked ? "var(--primary)" : "transparent"};
  cursor: pointer;

  input {
    display: none;
  }

  .checkedIcon {
    height: 100%;
    pointer-events: none;
  }
`;

const handleClick = (e, id) => {
  e.stopPropagation();
  const checkboxInput = document.querySelector(`input[type="checkbox"]#${id}`);

  checkboxInput.click();
};

const CheckBox = ({
  id,
  className,
  name,
  grey,
  circle,
  label,
  value,
  required = false,
  disabled,
  onChange,
  defaultChecked = false,
  ...props
}) => {
  const [checked, setChecked] = useState(defaultChecked);

  return (
    <Wrapper className="flexRow alignCenter checkBox">
      <Box
        grey={grey}
        circle={circle}
        checked={checked}
        onClick={(e) => handleClick(e, id)}
        className={className}
      >
        <input
          type="checkbox"
          name={name}
          id={`${id}`}
          checked={checked}
          value={value}
          onChange={(e) => {
            onChange && onChange(e);
            setChecked(!checked);
          }}
          required={required}
          disabled={disabled}
          {...props}
        />
        <img src={doneIconWhite} alt="check" className="checkedIcon" />
      </Box>
      {label && (
        <label htmlFor={`${id}`} className="l3 ellipsify">
          {label}
        </label>
      )}
    </Wrapper>
  );
};

CheckBox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  grey: PropTypes.bool,
  circle: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckBox;
